import React from 'react';
import { useTranslation } from 'react-i18next';
import { Combobox } from '@vwfs-bronson/bronson-react';
import { ComboboxOption, ComboboxState } from '@cp-shared-19/frontend-ui';
import { documentTypeTranslationMapping, PostboxDocumentType } from '../helper/DocumentType';

export type DocumentTypeSelectProps = {
    options: PostboxDocumentType[];
    value: PostboxDocumentType;
    onChange: (value: PostboxDocumentType) => void;
};

export const DocumentTypeSelect: React.FC<DocumentTypeSelectProps> = ({ options, value, onChange }) => {
    const { t, i18n } = useTranslation('postbox');

    const allOption = {
        key: 'ALL',
        value: {
            textValue: t('filters.document-type.select-items.all'),
            content: t('filters.document-type.select-items.all'),
        },
    };
    const optionElements = [
        allOption,
        ...options.map(option => ({
            key: option,
            value: {
                textValue: t(`filters.document-type.select-items.${documentTypeTranslationMapping[option]}`),
                content: t(`filters.document-type.select-items.${documentTypeTranslationMapping[option]}`),
            },
        })),
    ];

    const selectedOption = optionElements.find(option => option.key === value) ?? allOption;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectValueChange = (selected: any): void => {
        const selectedKey = selected?.[0]?.key as PostboxDocumentType | undefined;
        if (selectedKey && selectedKey !== value) {
            onChange(selectedKey);
        }
    };

    const defaultItem: ComboboxState = {
        value: [{ key: selectedOption.key, value: selectedOption.value.textValue }],
    };

    return (
        <>
            <label>{t('filters.document-type.label')}</label>
            <Combobox
                key={`${i18n.language}-${options.join(',')}`}
                testId={'DocumentTypeSelect'}
                onChange={selectValueChange}
                value={[(selectedOption as unknown) as ComboboxOption]}
                options={optionElements}
                defaultState={defaultItem}
                className="c-form-field--no-floating"
            />
        </>
    );
};
